import { Tabs } from "@veneer/core";
import React from "react";

interface CoursesTabsProps {
  selectedTabId: number;
  onChangeTab: (tabId: number) => void;
  tabs: {
    id: number;
    label: string;
    content: React.ReactNode;
  }[];
}

export const CoursesTabs: React.FC<CoursesTabsProps> = ({
  selectedTabId,
  onChangeTab,
  tabs,
}) => {
  return (
    <Tabs
      className="coursesTabs"
      controlId="coursesTabs"
      mode="contained"
      type="online"
      selectedTabId={selectedTabId}
      onChangeTab={onChangeTab}
      tabs={tabs}
    />
  );
};
